import { combineReducers } from 'redux';
import auth from './Auth';
import shop from './Shop';
import app from './App';

const appReducer = combineReducers({
    auth,
    shop,
    app
});

const initialState = appReducer({}, {}, {})

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = initialState
    }
    return appReducer(state, action)
}

export default rootReducer;